import {CLASSIC_LAYOUT_TYPE} from '../../constants'
import type {SingleComponentPluginFunction} from '../../types'
import type {ComponentWithResolvedDataItems} from '@wix/document-services-types'

export const pack: SingleComponentPluginFunction = (component: ComponentWithResolvedDataItems): void => {
    if (component.data.layout || !component.structure.layout) {
        return
    }

    component.data.layout = {
        default: {
            ...component.structure.layout,
            type: CLASSIC_LAYOUT_TYPE
        }
    }
    delete component.structure.layout
}
